import { TypographyP } from '@talentmesh/ui/components/typography';
import React from 'react';
import UIStrings from '../utils/UIStrings';
import ChipCloud from './ChipCloud';

interface RecruitmentInformationProps {
    tests: Array<string>;
}

function RecruitmentInformation({ tests }: RecruitmentInformationProps): React.JSX.Element {
    return (
        <div className="flex flex-col gap-4">
            <TypographyP className="text-base">{UIStrings.AllCandidatesCanApplyRegardlessOfJobExperience}</TypographyP>
            <TypographyP className="text-base">{UIStrings.AllCandidatesWillBeGivenAUniqueChance}</TypographyP>
            <ChipCloud chips={tests} />
        </div>
    );
}

export default RecruitmentInformation;
